import {CSSProperties, ReactNode} from "react";
import AnnotationRectangle from "./AnnotationRectangle";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import DomHelper from "../../../../shared/helper/DomHelper";
import {
	Annotation,
	AnnotationPointPoint,
	AnnotationPointPointInterface, BorderStyle, Markup,
	MetadataRectangle
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import EffectStyle from "./EffectStyle";

export class FreetextAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let freetextMarkerId: string = DomHelper.generateUUID();
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let lineBoundaries: MetadataRectangle = this.getLineBoundaries();
		let points: Array<AnnotationPointPoint> = this.getPoints();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");
		let opacity: number = FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100;

		if (points.length > 0) {
			lineBoundaries.width! -= lineBoundaries.x!;
			lineBoundaries.height! -= lineBoundaries.y!;

			let result: Array<AnnotationPointPoint> = [];
			for (let point of points) {
				result.push(AnnotationPointPoint.fromJson({
					x: point.x! - lineBoundaries.x!,
					y: lineBoundaries.height! - (point.y! - lineBoundaries.y!)
				} as AnnotationPointPointInterface));
			}

			points = result;
		}

		let border: Array<AnnotationPointPoint> = [
			AnnotationPointPoint.fromJson({x: 0, y: 0}),
			AnnotationPointPoint.fromJson({x: rectBoundaries.width, y: 0}),
			AnnotationPointPoint.fromJson({x: rectBoundaries.width, y: rectBoundaries.height}),
			AnnotationPointPoint.fromJson({x: 0, y: rectBoundaries.height})
		];

		let freetextStrokeColor: string = FunctionHelper.exists(annotation.border) ?
			annotation.border!.interiorColor! : color;

		let polylineStyles: CSSProperties = {
			opacity: opacity
		};

		if (FunctionHelper.exists(annotation.border)) {
			polylineStyles.strokeWidth = annotation.border!.width!.toString();
			polylineStyles.stroke = annotation.border!.interiorColor;

			if (annotation.border!.style === BorderStyle.Dashed) {
				polylineStyles.strokeDasharray = JSON.parse(annotation.border!.dashPattern!).join(",");
			}
		}

		let borderCloud: boolean = false;
		let annotationStyle: CSSProperties = {
			opacity: FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100,
			fill: color
		};

		if (FunctionHelper.exists(annotation.border)) {
			annotationStyle.stroke = annotation.border!.interiorColor;
			annotationStyle.strokeWidth = annotation.border!.width!.toString();

			if (annotation.border!.style === BorderStyle.Dashed) {
				annotationStyle.strokeDasharray = JSON.parse(annotation.border!.dashPattern!).join(",");
			} else if (annotation.border!.effectStyle === EffectStyle.CLOUD) {
				borderCloud = true;
				annotationStyle.stroke = "none";
			}
		}

		return (
			<>
				{points.length > 0 &&
				<AnnotationRectangle {...this.props}  popupColor={color} {...lineBoundaries}
									 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
									 popupContent={annotation.contents} popupCreator={annotation.markup?.creator}
									 creationDate={annotation.markup?.creationDate}
									 style={{
										 zIndex: 0
									 }}>
					<svg xmlns={SVG_NAMESPACE}>
						{this.renderMarker(freetextMarkerId, freetextStrokeColor, color)}
						<polyline points={points.reverse().map(point => point.x + "," + point.y).join(" ")}
								  markerStart={"url(#lineStart-" + freetextMarkerId + ")"}
								  markerEnd={"url(#lineEnd-" + freetextMarkerId + ")"}
								  style={polylineStyles}/>
					</svg>
				</AnnotationRectangle>
				}
				<AnnotationRectangle {...this.props}  popupColor={color} {...rectBoundaries}
									 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
									 popupContent={annotation.contents} popupCreator={annotation.markup?.creator}
									 creationDate={annotation.markup?.creationDate}
									 style={{
										 zIndex: 0
									 }}>
					<svg xmlns={SVG_NAMESPACE}>
						{borderCloud &&
						this.renderCloudBorder(border, annotation.border!.width!, annotation.border!.interiorColor!, color)
						}
						<rect x={0} y={0} width={rectBoundaries.width} height={rectBoundaries.height}
							  style={annotationStyle}/>
					</svg>
					<p style={{
						opacity: opacity,
						color: FunctionHelper.applyValue(annotation.border?.interiorColor, "black")
					}}>{annotation.contents}</p>
				</AnnotationRectangle>
			</>
		);
	}
}